<template>
  <div class="limiter">
    <div class="container-login">
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-card class="login" flat style="border-radius: 10px;padding: 10px;">
              <span class="login-title">
                <img src="../../assets/logoAiConsumer.png" width="100%" style="max-width: 300px">
              </span>
              <v-card-text style="padding: 0px; margin-top: 0px;">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg12>
                      <v-text-field v-if="!showTextField" label="Valor" outlined hide-details v-model="valorTransacao" v-money="money" prefix="R$" type="tel" color="#474d55" dense id="campoValor"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg6>
                      <v-btn depressed block outlined large style="border-radius: 7px; width: 100%" @click="abreLeituraQRCode('DEPÓSITO', 'CARTÃO')">
                        <v-icon left size="25">mdi-credit-card</v-icon>Depósito em Cartão
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 lg6>
                      <v-btn depressed block outlined large style="border-radius: 7px; width: 100%" @click="abreLeituraQRCode('DEPÓSITO', 'ESPÉCIE')">
                        <v-icon left size="25">mdi-cash</v-icon>Depósito em Espécie</v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 lg6>
                      <v-btn depressed block outlined large style="border-radius: 7px; width: 100%" @click="abreLeituraQRCode('DEPÓSITO', 'PIX')">
                        <img style="margin-right: 5px" src="../../assets/pix.png" width="18px">Depósito em Pix
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 lg6>
                      <v-btn depressed block outlined large style="border-radius: 7px; width: 100%" @click="abreLeituraQRCode('CONSULTA', '')">
                        <v-icon left size="25">mdi-magnify</v-icon>Consultar Saldo
                      </v-btn>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 lg12>
                      <v-btn depressed block outlined large style="border-radius: 7px; width: 100%" @click="dialogoTransferirSaldo = true; tipoTransacao = 'TRANSFERÊNCIA'">
                        <v-icon left>mdi-swap-horizontal-bold</v-icon>Transferir Saldo
                      </v-btn>
                    </v-flex> -->
                    <v-flex xs12 sm12 lg12>
                      <v-btn dark depressed block  color="#F57F17" large style="border-radius: 7px; width: 100%" @click="abreLeituraQRCode('SAQUE')">
                        <v-icon left>wallet</v-icon>Saque
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-btn dark depressed block color="#E53935" large style="border-radius: 7px; width: 100%" @click="abreDialogoMovimentacoes('sangria')">
                        <v-icon left>currency_exchange</v-icon>Fazer Sangria
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-btn dark depressed block color="teal" large style="border-radius: 7px; width: 100%" @click="fecharCaixa()">
                        <v-icon left>point_of_sale</v-icon>Fechar Caixa
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-card outlined>
                        <v-card-title style="font-size: 15px; padding-top: 5px; padding-bottom: 5px">Últimas recargas</v-card-title>
                        <div v-show="!tabela.carregamentoTransacoesMinizado">
                          <v-col cols="12" xs="12" sm="12" md="12" lg="12" v-for="transacao in tabela.conteudoTransacoesMinizado" :key="transacao.id" justify-center style="padding: 0px">
                            <v-list dense>
                              <v-list-item>
                                <v-list-item-avatar style="margin-top: 0px; margin-bottom: 0px">
                                  <v-avatar color="success">
                                    <v-icon dark left size="30">mdi-cash-plus</v-icon>
                                  </v-avatar>
                                </v-list-item-avatar>

                                <v-list-item-content style="padding: 0px">
                                  <v-list-item-title>{{ transacao.consumidor && transacao.consumidor.nome ? transacao.consumidor.nome : 'Consumidor removido' }}</v-list-item-title>
                                  <v-list-item-subtitle>{{ formatDate(transacao.created.substring(0, 10)).substring(0, 5) }} às {{ transacao.created.substring(11, 16) }}</v-list-item-subtitle>
                                </v-list-item-content>

                                <v-list-item-action>
                                  <v-list-item-subtitle><b>R$ {{ transacao.valor }}</b></v-list-item-subtitle>
                                </v-list-item-action>
                              </v-list-item>
                            </v-list>
                            <v-divider></v-divider>
                          </v-col>
                        </div>
                        <div v-show="tabela.carregamentoTransacoesMinizado" style="text-align: center; padding: 10px">
                          <v-progress-circular indeterminate></v-progress-circular>
                          <p>Carregando últimas recargas...</p>
                        </div>
                        <div v-show="!tabela.carregamentoTransacoesMinizado && tabela.conteudoTransacoesMinizado.length == 0" style="text-align: center; padding: 10px">
                          <v-alert class="mb-0" type="info" dense text>Nenhuma transação realizada</v-alert>
                        </div>
                        <v-btn v-show="!tabela.carregamentoTransacoesMinizado && tabela.conteudoTransacoesMinizado.length > 0" style="width: 100%" @click="mostraHistorico" text>
                          <v-icon left>history</v-icon>Ver mais
                        </v-btn>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <br>
        <div class="login-title">
          <a href="https://www.intelitetecnologia.com.br/" target="_blank">
            <img src="../../assets/logo-branco-orizontal.png" width="150px">
          </a>
        </div>
      </v-container>

      <v-dialog persistent v-model="dialogoCaptura" max-width="600px">
        <v-card>
          <v-card-title>Leitura do cartão</v-card-title>
          <v-card-text style="padding: 0px">
            <v-row dense style="margin: 0px; text-align: center">
              <v-col cols="12">
                <img width="200px" src="../../assets/iconContactless.png">
              </v-col>
              <v-col cols="12">
                <h3>Aproxime o cartão no leitor da maquineta</h3>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="red" @click="fechar(); valorTransacao = '0,00'">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="dialogoCriaPin" max-width="400px">
        <v-card>
          <v-card-title>Criar PIN</v-card-title>
          <v-card-text style="padding-bottom: 0px">
            <p>Crie um código PIN para efetuar depositos e saques. O PIN deverá ter 04 (quatro) números.</p>
            <v-otp-input length="4" color="#474d55" type="number" v-model="pin"></v-otp-input>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary" :disabled="pin.length < 4" @click="salvarPin">Continuar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="dialogoSolicitaPin" max-width="400px">
        <v-card>
          <v-card-title>Informe seu PIN</v-card-title>
          <v-card-text style="padding-bottom: 0px">
            <p>Informe o código PIN para continuar</p>
            <!-- <v-otp-input id="pinTransacao" length="4" color="#474d55" type="number" v-model="pinTransacao"></v-otp-input> -->
            <v-otp-input id="pinTransacao" autofocus="true" length="4" color="#474d55" type="number" v-model="pinTransacao" @finish="criarTransacao"></v-otp-input>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="fechar">Fechar</v-btn>
            <v-btn text color="primary" :disabled="pinTransacao.length < 4" @click="criarTransacao" v-if="tipoTransacao != 'TRANSFERÊNCIA'">Continuar</v-btn>
            <v-btn text color="primary" :disabled="pinTransacao.length < 4" @click="fazerTransferenciaValor" v-else>Continuar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="dialogoSolicitaPinMovimentacao" max-width="400px">
        <v-card>
          <v-card-title>Informe seu PIN</v-card-title>
          <v-card-text style="padding-bottom: 0px">
            <p>Informe o código PIN para continuar</p>
            <v-otp-input id="pinTransacao" length="4" color="#474d55" type="number" v-model="pinTransacao"></v-otp-input>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="dialogoSolicitaPinMovimentacao = false">Fechar</v-btn>
            <v-btn text color="primary" :disabled="pinTransacao.length < 4" @click="continuaMovimentacao()">Continuar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="dialogoOperacao" max-width="600px">
        <v-card>
          <v-card-text style="padding-bottom: 0px; text-align: center">
            <v-icon size="100" :color="respostaTransacao.resultado == 'SUCESSO' ? 'success' : 'error'">{{ respostaTransacao.resultado == 'SUCESSO' ? 'check_circle' : 'error' }}</v-icon>
            <h1 style="margin: 0px; font-weight: 300">{{ respostaTransacao.consumidor }}</h1>
            <h3 style="margin-bottom: 0px; margin-top: 10px">Saldo</h3>
            <h1 style="margin: 0px; font-weight: 300; margin-top: 10px">R$ {{ respostaTransacao.saldo }}</h1>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="red" @click="fechar">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="dialogoCadastraConsumidor" max-width="400px">
        <v-card>
          <v-card-title>Cadastrar Consumidor</v-card-title>
          <v-card-subtitle style="color: blue">Preenchimento opcional</v-card-subtitle>
          <v-card-text style="padding-bottom: 0px">
            <v-row dense>
              <v-col cols="12">
                <v-text-field label="Matrícula" outlined dense hide-details v-model="consumidor.matricula" type="tel" @blur="consultaMatricula"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field label="CPF" outlined dense hide-details v-model="consumidor.cpf" v-validate="'required|cpf'" :error-messages="errors.collect('cpf')" data-vv-name="cpf" type="tel" v-mask="'###.###.###-##'"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field label="Nome e sobrenome" outlined dense hide-details v-model="consumidor.nome"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field label="WhatsApp com DDD" outlined dense v-model="consumidor.whatsApp" v-mask="'(##) #####-####'" persistent-hint hint="As notificações serão enviadas para o número informado" type="tel"></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="dialogoCadastraConsumidor = false; document.getElementById('campoValor').value = '0,00'">Fechar</v-btn>
            <v-btn text color="primary" @click="criarConsumidor">Continuar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="depositDialog" max-width="500px">
        <v-card>
          <v-card-title>Depósito em Cartão</v-card-title>
          <v-card-text>
            <v-tabs dark centered color="deep-purple-accent-4" v-model="activeTab">
              <v-tab key="tab-1">Quero cobrar</v-tab>
              <v-tab key="tab-2">Quero receber</v-tab>
              <v-tab-item key="content-1">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg12>
                      <v-text-field v-if="showTextField" label="Valor a Cobrar" @keyup="calculaDesconto(valorTransacaoCartaoDesconto)" outlined hide-details v-model="valorTransacaoCartaoDesconto" v-money="money" prefix="R$" type="tel" color="#474d55" dense id="campoValor2"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-text-field v-if="showTextField" label="Valor para Consumo" disabled outlined hide-details v-model="valorComDesconto" prefix="R$" type="tel" color="#474d55" dense id="campoValor3"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg6>
                      <v-btn depressed block outlined large style="border-radius: 7px; width: 100%" @click="abreLeituraQRCode('DEPÓSITO', 'CARTÃO', valorTransacaoCartaoDesconto)">
                        <v-icon left size="25">mdi-credit-card</v-icon>Continuar Depósito
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-tab-item>
              <v-tab-item key="content-2">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg12>
                      <v-text-field v-if="showTextField" label="Valor a receber" disabled outlined hide-details v-model="valorComAcressimo" prefix="R$" type="tel" color="#474d55" dense id="campoValor4"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-text-field v-if="showTextField" label="Valor Para Consumo" @keyup="calculaAcressimo(valorTransacaoCartaoAcressimo)" outlined hide-details v-model="valorTransacaoCartaoAcressimo" v-money="money" prefix="R$" type="tel" color="#474d55" dense id="campoValor5"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg6>
                      <v-btn depressed block outlined large style="border-radius: 7px; width: 100%" @click="abreLeituraQRCode('DEPÓSITO', 'CARTÃO', valorComAcressimo)">
                        <v-icon left size="25">mdi-credit-card</v-icon>Continuar Depósito
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-tab-item>
            </v-tabs>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="fecharDialogCartao">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogoPagamentoPix" persistent max-width="600px">
        <v-card>
          <v-card-title>Pagamento</v-card-title>
          <v-card-text style="text-align: center; padding-bottom: 0px">
            <v-container>
              <v-row align="center" justify="center">
                <v-col cols="12" style="padding: 1px">
                  <v-card flat color="#ffffff">
                    <qrcode-vue v-if="companyobj.gatewayPagamentoPix == 'SICOOB'" :value="cobrancaPix.qrCode" :size="300" level="H" bg-color="white"></qrcode-vue>
                    <img v-else :src="cobrancaPix.qrCode" width="100%" style="max-width: 300px">
                  </v-card>
                </v-col>
              </v-row>
              <v-row align="center" justify="center">
                <v-col cols="12" style="padding: 1px;">
                  <p class="texto" style="color: orange">R$ {{valorTransacao}}</p>
                </v-col>
                <v-col cols="12" style="padding: 1px;">
                  <p class="texto" style="color: #00695C" v-if="companyobj.gatewayPagamentoPix == 'ASSAS'">Nome Fantasia: INTELITE TECNOLOGIA</p>
                  <p class="texto" style="color: #00695C" v-if="companyobj.gatewayPagamentoPix == 'TAPAGO'">Nome Fantasia: INTELITE TECNOLOGIA FLAGSHIP</p>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn style="border-radius: 7px;" dark depressed block color="#00695C" @click="dialogoPagamentoPix = false">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogoConfirmacao" persistent max-width="400px">
        <v-card>
          <v-card-text style="text-align: center; padding-bottom: 0px">
            <v-container>
              <v-row align="center" justify="center">
                <v-col cols="12" style="padding-bottom: 0px;">
                  <v-icon color="success" size="100">check_circle</v-icon>
                </v-col>
                <v-col cols="12" style="padding: 2px;">
                  <p class="texto" style="color: #666; margin: 0px">Recarga realizada com sucesso!</p>
                  <p class="texto" style="color: #666; margin: 0px" v-if="saldoCartao">Saldo: R$ {{saldoCartao}}</p>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="dialogoConfirmacao = false">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogoPerguntaPagamentoPix" persistent max-width="400px">
        <v-card>
          <v-card-title>Como deseja receber o Pix?</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-btn block color="primary" @click="dialogoSolicitaPin = true; dialogoPerguntaPagamentoPix = false">
                  <v-icon left>mdi-credit-card</v-icon>Outra maquineta
                </v-btn>
              </v-col>
              <v-col cols="12">
                <v-btn block color="#15AAF4" dark @click="fechaDialogoPerguntaPagamento">
                  <v-icon left>mdi-cellphone</v-icon>Neste terminal
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogoAbrirCaixa" persistent max-width="400px">
        <v-card>
          <v-card-title>Valor para a abertura do caixa</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-flex xs12 sm12 lg12>
                  <v-text-field label="Valor de Abertura" v-money="money" prefix="R$" outlined hide-details v-model="valorAberturaCaixa" type="tel" color="#474d55" id="campoAbreCaixa" dense></v-text-field>
                </v-flex>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn dark color="primary" @click="abreCaixa()">Abrir Caixa</v-btn>
            <v-btn dark color="red" @click="Sair()">Sair da Conta</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogoFecharCaixa" persistent max-width="400px">
        <v-card>
          <v-card-title>Resumo do Caixa</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="6" lg="6">
                  <v-text-field label="Abertura" disabled prefix="R$" outlined hide-details v-model="resumo.abertura" type="tel" color="#474d55" dense></v-text-field>
              </v-col>
              <v-col cols="6">
                  <v-text-field label="Espécie" disabled prefix="R$" outlined hide-details v-model="resumo.especie" type="tel" color="#474d55" dense></v-text-field>
              </v-col>
              <v-col cols="6">
                  <v-text-field label="Cartão" disabled prefix="R$" outlined hide-details v-model="resumo.cartao" type="tel" color="#474d55" dense></v-text-field>
              </v-col>
              <v-col cols="6">
                  <v-text-field label="PIX" disabled prefix="R$" outlined hide-details v-model="resumo.pix" type="tel" color="#474d55" dense></v-text-field>
              </v-col>
              <v-col cols="6">
                  <v-text-field label="Sangria" disabled prefix="R$" outlined hide-details v-model="resumo.sangria" type="tel" color="#474d55" dense></v-text-field>
              </v-col>
              <v-col cols="6">
                  <v-text-field label="Saque" disabled prefix="R$" outlined hide-details v-model="resumo.saque" type="tel" color="#474d55" dense></v-text-field>
              </v-col>
              <v-col cols="12">
                  <span>
                    Total em Espécie no Caixa: R$ <strong class="subheading">{{totalEmCaixaEspecie}}</strong>
                  </span>
              </v-col>
              <v-col cols="12">
                <v-flex xs12 sm12 lg12>
                  <span>
                    Total no Caixa: R$ <strong class="subheading">{{totalEmCaixa}}</strong>
                  </span>
                </v-flex>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn dark color="teal" @click="abreDialogoMovimentacoes('fecharCaixa')">Fechar Caixa</v-btn>
            <v-btn dark color="red" @click="dialogoFecharCaixa = false">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogoSangria" max-width="400px">
        <v-card>
          <v-card-title>Qual o valor da sangria?</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-flex xs12 sm12 lg12>
                  <v-text-field label="Valor da Sangria" v-money="money" prefix="R$" outlined hide-details v-model="valorSangria" type="tel" id="campoSangria" color="#474d55" dense></v-text-field>
                </v-flex>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn dark color="teal" @click="fazerSangria()">Confirmar</v-btn>
            <v-btn dark color="#E53935" @click="fecharSangria()">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogoTransferirSaldo" persistent max-width="400px">
        <v-card>
          <v-card-title>Transferir saldo</v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col cols="12">
                <v-radio-group v-model="tipoBusca" @mouseup="dadoTransferencia = ''">
                  <v-radio label="CPF" value="CPF"></v-radio>
                  <v-radio label="Telefone" value="TELEFONE"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12">
                <v-text-field outlined dense hide-details label="Informe o CPF" v-mask="'###.###.###-##'" v-model="dadoTransferencia" v-if="tipoBusca == 'CPF'" v-validate="'required|cpf'" :error-messages="errors.collect('cpf')" data-vv-name="cpf" type="tel"></v-text-field>
                <v-text-field outlined dense hide-details label="Informe o telefone" v-mask="'(##) #####-####'" v-model="dadoTransferencia" v-if="tipoBusca == 'TELEFONE'"></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogoTransferirSaldo = false" color="red">Fechar</v-btn>
            <v-btn text @click="buscaConsumidor" color="primary">Continuar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogoExibeConsumidoreCartao" persistent max-width="800px" scrollable>
        <v-card>
          <v-toolbar color="#474d55" dark dense>
            <v-toolbar-title></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="dialogoExibeConsumidoreCartao = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text style="padding: 0px">
            <v-data-table
              v-model="cartoesSelecionados"
              :headers="tabela.cabecalho"
              :items="tabela.conteudo"
              :search="tabela.busca"
              :single-select="false"
              item-key="cartaoConsumoId"
              show-select
              :footer-props="{
                'items-per-page-text': 'Linhas por página',
                'items-per-page-all-text': 'Tudo',
              }"
            >
              <template v-slot:top>
                <v-toolbar dark color="blue darken-3" class="mb-0" flat>
                  <v-text-field v-model="tabela.busca" dense clearable flat solo-inverted hide-details prepend-inner-icon="mdi-magnify" label="Pesquisa"></v-text-field>
                </v-toolbar>
              </template>
              <template v-slot:[`item.saldo`]="{ item }">
                <td>R$ {{ item.saldo }}</td>
              </template>
              <template v-slot:[`item.qrCode`]="{ item }">
                <td>{{ item.qrCode.substring(item.qrCode.length, item.qrCode.length - 6) }}</td>
              </template>
              <template v-slot:[`item.created`]="{ item }">
                <td>{{ transformaData(item.created, 'DD/MM/YYYY') }} às {{ transformaData(item.created, 'HH:mm') }}</td>
              </template>
            </v-data-table>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="dialogoLeituraQRCodeTransferencia = true; dialogoExibeConsumidoreCartao = false" :disabled="cartoesSelecionados.length == 0">Continuar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="dialogoLeituraQRCodeTransferencia" max-width="600px">
        <v-card>
          <v-card-title>Leitura do QR Code</v-card-title>
          <v-card-text style="padding: 0px">
            <qrcode-stream @decode="salvaLeituraQRCodeTransferencia" v-if="dialogoLeituraQRCodeTransferencia"></qrcode-stream>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="red" @click="dialogoLeituraQRCodeTransferencia = false">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="dialogoHistorico" transition="dialog-bottom-transition" max-width="600px" scrollable>
        <v-card>
          <v-toolbar color="#474d55" dark dense>
            <v-toolbar-title>Histórico</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="dialogoHistorico = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text style="padding: 0px">
            <v-data-iterator :items="tabela.conteudoTransacoesCompleto" :items-per-page.sync="tabela.itensPorPagina" :page.sync="tabela.pagina" :loading="tabela.carregamentoTransacoesCompleto" :search="tabela.busca">
              <template v-slot:header>
                <v-toolbar dark color="blue darken-3" class="mb-0">
                  <v-text-field v-model="tabela.busca" dense clearable flat solo-inverted hide-details prepend-inner-icon="mdi-magnify" label="Pesquisa"></v-text-field>
                </v-toolbar>
              </template>
              <template v-slot:no-results>
                <v-alert style="margin: 10px" type="info" dense text>Sua busca por "{{ tabela.busca }}" não trouxe resultados</v-alert>
              </template>
              <template v-slot:no-data>
                <v-alert style="margin: 10px" type="info" dense text>Nenhum registro localizado</v-alert>
              </template>
              <template v-slot:loading>
                <div style="text-align: center; padding: 20px">
                  <p style="margin-bottom: 5px">Aguarde, carregando itens...</p>
                  <v-progress-linear indeterminate></v-progress-linear>
                </div>
              </template>
              <template v-slot:default="props">
                <v-col v-for="item in props.items" :key="item.name" cols="12" style="padding: 0px">
                  <v-list dense>
                    <v-list-item @click="item.tipoTransacao == 'CONSUMO' ? efetuarEstorno(item) : ''">
                      <v-list-item-avatar style="margin-top: 0px; margin-bottom: 0px">
                        <v-avatar color="success">
                          <v-icon dark left size="30">mdi-cash-plus</v-icon>
                        </v-avatar>
                      </v-list-item-avatar>

                      <v-list-item-content style="padding: 0px">
                        <v-list-item-title>{{ item.nome }}</v-list-item-title>
                        <v-list-item-subtitle>{{ formatDate(item.created.substring(0, 10)).substring(0, 5) }} às {{ item.created.substring(11, 16) }}</v-list-item-subtitle>
                      </v-list-item-content>

                      <v-list-item-action>
                        <v-list-item-subtitle><b>R$ {{ item.valor }}</b></v-list-item-subtitle>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                  <v-divider></v-divider>
                </v-col>
              </template>
            </v-data-iterator>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogoSelecaoMetodo" max-width="400px" persistent>
        <v-card>
          <v-card-title>Método de Identificação</v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-btn block color="primary" @click="selecionarMetodo('nfc')" height="70">
                    <v-icon left large>mdi-cellphone-nfc</v-icon>
                    Aproximação
                  </v-btn>
                </v-col>
                <v-col cols="12">
                  <v-btn block color="success" @click="selecionarMetodo('facial')" height="70">
                    <v-icon left large class="mr-4">mdi-face-recognition</v-icon>
                    Facial
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="red" @click="dialogoSelecaoMetodo = false">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogoCamera" max-width="500px" persistent>
        <v-card>
          <v-card-title style="padding: 5px 15px 5px 15px">
            Câmera
            <v-spacer></v-spacer>
            <v-btn @click="dialogoCamera = false; codigoQrCode = ''" icon>
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" style="padding: 12px 0px">
                <v-item-group v-model="modoCaptura">
                  <v-item v-for="opcao in opcoesCaptura" :key="opcao.value" :value="opcao.value" v-slot="{ active, toggle }">
                    <v-chip label active-class="primary" :input-value="active" @click="toggle" class="mr-3">
                      <v-icon small left v-if="active">mdi-check</v-icon>
                      {{ opcao.text }}
                    </v-chip>
                  </v-item>
                </v-item-group>
              </v-col>

              <v-col cols="12" v-if="modoCaptura == 'FACIAL'" style="padding: 0px">
                <CameraView
                  ref="camera"
                  :ativo="modoCaptura == 'FACIAL' && dialogoCamera"
                  @cameras-detectadas="totalCameras = $event"
                />

                <div align="center" justify="center" style="padding-bottom: 8px">
                  <v-btn
                    v-if="totalCameras > 1"
                    @click="$refs.camera.alternarCamera()"
                    fab
                    dark
                    class="mr-3"
                  >
                    <v-icon large>mdi-camera-flip</v-icon>
                  </v-btn>
                  <v-btn
                    @click="capturarFoto"
                    fab
                    dark
                    depressed
                  >
                    <v-icon large>mdi-camera-iris</v-icon>
                  </v-btn>
                </div>
              </v-col>

              <v-col cols="12" v-else style="padding: 0px">
                <v-autocomplete
                  :loading="autocompleteConsumidor.carregamento"
                  :search-input.sync="autocompleteConsumidor.busca"
                  cache-items
                  :items="autocompleteConsumidor.conteudo"
                  :filter="filterConsumidores"
                  item-text="nome"
                  item-value="qrCode"
                  :label="modoCaptura == 'MATRÍCULA' ? 'Matrícula do consumidor' : 'Nome do consumidor'"
                  outlined
                  hide-details
                  v-model="codigoQrCode"
                  no-data-text="Nenhum consumidor encontrado"
                  clearable
                >
                  <template v-slot:item="{ item }">
                    <v-list-item-avatar>
                      <v-img v-if="item.foto" :src="item.foto"></v-img>
                      <v-icon v-else>mdi-account</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>{{ item.nome }}</v-list-item-title>
                      <v-list-item-subtitle>{{ item.cpf }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                  <template v-slot:selection="{ item }">
                    <v-list-item-avatar>
                      <v-img v-if="item.foto" :src="item.foto"></v-img>
                      <v-icon v-else>mdi-account</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>{{ item.nome }}</v-list-item-title>
                      <v-list-item-subtitle>{{ item.cpf }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions v-if="modoCaptura != 'FACIAL'">
            <v-spacer></v-spacer>
            <v-btn v-if="tipoTransacao == 'CONSULTA'" text color="primary" :disabled="Boolean(!codigoQrCode)" @click="dialogoCamera = false; fazerConsultaSaldo(codigoQrCode)">Continuar</v-btn>
            <v-btn v-else text color="primary" :disabled="Boolean(!codigoQrCode)" @click="dialogoCamera = false; dialogoSolicitaPin = true">Continuar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <loading :active.sync="isLoading" :can-cancel="true" color="#474d55" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </div>
</template>

<script>
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import Snackbar from '../../componentes/snackbar.vue'
  import { mapState } from 'vuex'
  import axios from 'axios'
  import { VMoney } from 'v-money'
  import moment from 'moment'
  import QrcodeVue from 'qrcode.vue'
  import CameraView from '../../componentes/CameraView.vue'
  //import CpfValidate from '../../componentes/validators/rules/cpf'
  export default {
    components: { Snackbar, Loading, QrcodeVue, CameraView, },
    name: 'Caixa',
    data() {
      return {
        dataInicio: new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        dataFim: new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        horaInicio: '00:00',
        horaFim: '23:59',
        resumo: {
          abertura: '0,00',
          cartao: '0,00',
          pix: '0,00',
          sangria: '0,00',
          saque: '0,00',
          especie: '0,00'
        },
        usuario: '',
        pin: '',
        pinTransacao: '',
        dialogoSolicitaPinMovimentacao: false,
        valorTransacao: 0.00,
        valorAberturaCaixa: '0,00',
        valorSangria: '0,00',
        tipoTransacao: '',
        formaTransacao: '',
        codigoQrCode: '',
        money: {
          decimal: ',',
          thousands: '.',
          prefix: '',
          suffix: '',
          precision: 2,
          masked: false
        },
        consumidor: {
          nome: '',
          cpf: '',
          whatsApp: '',
          qrCode: '',
          matricula: '',
        },
        cobrancaAsaas: {
          customer: '',
          billingType: 'PIX',
          value: 0,
          dueDate: '',
          description: ''
        },
        defaultCobrancaAsaas: {
          customer: '',
          billingType: 'PIX',
          value: 0,
          dueDate: '',
          description: ''
        },
        cobrancaPix: {
          id: '',
          qrCode: '',
          chaveCopiaCola: '',
        },
        fullPage: true,
        isLoading: false,
        respostaTransacao: [],
        audio: '',
        dialogoCriaPin: false,
        dialogoSolicitaPin: false,
        dialogoCaptura: false,
        dialogoCadastraConsumidor: false,
        dialogoOperacao: false,
        dialogoPagamentoPix: false,
        verificaPagamento: null,
        dialogoConfirmacao: false,
        saldoCartao: '',
        gatewayPagamentoPix: '',
        dialogoPerguntaPagamentoPix: false,
        valorComDesconto: 0,
        valorDoDesconto: 0,
        depositDialog: false,
        valorTransacaoCartaoDesconto: 0,
        valorTransacaoCartaoAcressimo: 0,
        showTextField: 0,
        valorComAcressimo: 0,
        valorDoAcressimo: 0,
        activeTab: null,
        dialogoTransferirSaldo: false,
        dialogoExibeConsumidoreCartao: false,
        dialogoLeituraQRCodeTransferencia: false,
        dadoTransferencia: '',
        tipoBusca: '',
        codigoTransferencia: '',
        cartoesSelecionados: [],
        dialogoAbrirCaixa: false,
        dialogoFecharCaixa: false,
        dialogoSangria: false,
        extratoAtendente: [],
        totalEmCaixaEspecie: '0,00',
        movimentacao: '',
        totalEmCaixa: '0,00',
        tabela: {
          busca: '',
          cabecalho: [
            { text: 'Consumidor', value: 'consumidor'},
            { text: 'Saldo', value: 'saldo'},
            { text: 'Código', value: 'qrCode'},
            { text: 'Criado em', value: 'created'},
          ],
          carregamentoTransacoesCompleto: false,
          carregamentoTransacoesMinizado: false,
          conteudo: [],
          conteudoTransacoesCompleto: [],
          conteudoTransacoesMinizado: [],
        },
        dialogoHistorico: false,
        dialogoCamera: false,
        dialogoSelecaoMetodo: false,
        metodoTransacao: '',
        modoCaptura: 'FACIAL',
        opcoesCaptura: [
          { text: 'Facial', value: 'FACIAL' },
          { text: 'Matrícula', value: 'MATRÍCULA' },
          { text: 'Nome', value: 'NOME' },
        ],
        autocompleteConsumidor: {
          busca: '',
          carregamento: false,
          conteudo: [],
          timeoutId: null,
        },
        totalCameras: 1,
      }
    },

    watch: {
      dialogoSolicitaPin() {
        if (this.dialogoSolicitaPin == true) {
          setTimeout(() => {
            document.getElementById('pinTransacao--0').focus()
          }, 400);
        }
      },

      dialogoOperacao() {
        if (this.dialogoOperacao == false) {
          this.respostaTransacao = []
          document.getElementById('campoValor').value = '0,00'
        }
      },

      dialogoPagamentoPix() {
        if (this.dialogoPagamentoPix == false) {
          this.cobrancaAsaas = Object.assign({}, this.defaultCobrancaAsaas)
          clearInterval(this.verificaPagamento)
          document.getElementById('campoValor').value = '0,00'
        }
      },

      dialogoCadastraConsumidor() {
        if (this.dialogoCadastraConsumidor == false) {
          this.consumidor.nome = ''
          this.consumidor.whatsApp = ''
          this.consumidor.cpf = ''
          this.consumidor.matricula = ''
        }
      },

      dialogoConfirmacao() {
        if (this.dialogoConfirmacao == false) {
          document.getElementById('campoValor').value = '0,00'
        }
      },

      dialogoExibeConsumidoreCartao() {
        if (this.dialogoExibeConsumidoreCartao == false) {
          this.dadoTransferencia = ''
        }
      },

      dialogoCriaPin() {
        if (this.dialogoCriaPin == false) {
          if (!this.usuario.caixaAberto) {
            this.dialogoAbrirCaixa = true
          }
        }
      },

      dialogoCaptura() {
        if (this.dialogoCaptura == true) {
          sessionStorage.removeItem('nfc')

          let interval = setInterval(() => {
            if (sessionStorage.getItem('nfc')) {
              this.decodificar(sessionStorage.getItem('nfc'))
              clearInterval(interval)
            }
          }, 1000);
        }
      },

      dialogoHistorico() {
        if (this.dialogoHistorico == false) {
          setTimeout(() => {
            this.tabela.conteudoTransacoesCompleto = []
          }, 500);
        }
      },

      dialogoCamera(newValue) {
        if (!newValue) {
          this.autocompleteConsumidor.busca = ''
          this.autocompleteConsumidor.conteudo = []
        }
        else if (newValue) {
          //
        }
      },

      modoCaptura() {
        if (this.modoCaptura == 'FACIAL' && this.dialogoCamera) {
          //
        }
        else {
          //
        }

        this.codigoQrCode = ''
        this.autocompleteConsumidor.busca = ''
        this.autocompleteConsumidor.conteudo = []
      },

      'autocompleteConsumidor.busca'(val) {
        if (this.autocompleteConsumidor.timeoutId) {
          clearTimeout(this.autocompleteConsumidor.timeoutId)
        }

        if (val && val.length >= 3) {
          this.autocompleteConsumidor.timeoutId = setTimeout(() => {
            if (val && val !== this.pacientes) {
              this.carregaConsumidores(val)
            }
          }, 500)
        }
        else {
          this.autocompleteConsumidor.conteudo = []
        }
      },
    },

    computed: mapState({
      user: state => state.userObj,
      companyobj: state => state.companyObj,
    }),

    mounted() {
      if (sessionStorage.getItem('userPermission') == 'CAIXA' && sessionStorage.getItem('accToken')) {
        if (sessionStorage.getItem('userPermission') != null)
          this.$store.dispatch('Permission')
      }
      this.audio = new Audio(require("../../assets/beep.mp3"))
      this.usuario = JSON.parse(sessionStorage.getItem('user'))
      if (!this.usuario.pin) {
        this.dialogoCriaPin = true
      }
      // this.pegaConfiguracoes()
      this.mostraTransacoes()

      if (this.usuario.pin) {
        if (!this.usuario.caixaAberto) {
          this.dialogoAbrirCaixa = true
        }
      }
    },

    methods: {
      async pegaConfiguracoes() {
        await axios.get(baseApiUrl + 'Configuracoes/findOne?filter={"fields":{"gatewayPagamentoPix": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data) {
            this.gatewayPagamentoPix = response.data.gatewayPagamentoPix
          }
        })
      },

      fecharSangria() {
        this.dialogoSangria = false
        document.getElementById('campoSangria').value = '0,00'
      },

      continuaMovimentacao() {
        if (this.movimentacao == 'sangria')
          this.dialogoSangria = true;

        if (this.movimentacao == 'fecharCaixa')
          this.confirmarFechamento()

        this.dialogoSolicitaPinMovimentacao = false;
      },

      abreDialogoMovimentacoes(movimentacao) {
        this.pinTransacao = ''
        if (movimentacao == 'sangria') {
          this.dialogoSolicitaPinMovimentacao = true
          this.movimentacao = 'sangria'
        }

        if (movimentacao == 'fecharCaixa') {
          this.dialogoSolicitaPinMovimentacao = true;
          this.movimentacao = 'fecharCaixa'
        }
      },

      Sair() {
        this.$store.dispatch('Sair')
        this.$router.push({ path: '/login' })
      },

      async fazerSangria() {
        let vm = this
        let resultado = await this.realizarTransacao('SANGRIA_CAIXA', '', this.valorSangria)

        if (resultado != 'SUCESSO') {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#EF5350", resultado, "DESCULPE")
        }
        else {
          vm.$refs.chamaSnackbar.snack("#0288D1","Sangria realizada no valor de R$ "+ this.valorSangria +"!","SUCESSO")
          document.getElementById('campoSangria').value = '0,00'
          this.dialogoSangria = false
        }
      },

      async abreCaixa() {
        let vm = this
        let resultado = await this.realizarTransacao('ABERTURA_CAIXA', '', this.valorAberturaCaixa)

        if (resultado != 'SUCESSO') {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#EF5350", resultado, "DESCULPE")
        }
        else {
          document.getElementById('campoAbreCaixa').value = '0,00'
          await axios.patch(baseApiUrl + 'Usuarios/' + this.user.id + '?access_token=' + sessionStorage.getItem('accToken'), {"caixaAberto": true})
          .then(response => {
            if (response.data) {
              sessionStorage.setItem('user', JSON.stringify(response.data))
              this.dialogoAbrirCaixa = false
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#0288D1","Caixa Aberto com Sucesso!","INFORMAÇÃO")
            }
          })
          .catch(() => {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao atualizar usuário","DESCULPE")
          })
        }
      },

      calculaDesconto(valorTransacaoCartao) {
        const porcentagemDeDesconto = 0.05;

        if (this.valorTransacao) {
          // Converta "50,00" para 50.00
          const valorNumerico = valorTransacaoCartao.replace(',','.');

          this.valorDoDesconto = parseFloat(valorNumerico * porcentagemDeDesconto);
          this.valorComDesconto = valorNumerico - this.valorDoDesconto;
          this.valorComDesconto =  this.valorComDesconto.toFixed(2).replace('.', ',')
        } else {
          this.valorDoDesconto = 0;
          this.valorComDesconto = 0;
        }
      },

      calculaAcressimo(valorTransacaoCartao) {
        if (this.valorTransacao) {
          const valorNumerico = valorTransacaoCartao.replace(',','.');

          this.valorComAcressimo = parseFloat(valorNumerico) / 0.95;
          this.valorComAcressimo =  this.valorComAcressimo.toFixed(2).replace('.', ',')
        } else {
          this.valorDoAcressimo = 0;
          this.valorComAcressimo = 0;
        }
      },

      async fecharCaixa() {
        this.extratoAtendente = []
        this.isLoading = true
        // Construção básica do filtro
        let filtro = {
          "where": {
            "and": [
              {"created": {"gt": `${this.dataInicio}T${this.horaInicio}:00.000Z`}},
              {"created": {"lt": `${this.dataFim}T${this.horaFim}:00.000Z`}}
            ]
          },
          "include": ["atendente"]
        };

        // Filtro para atendente
        filtro.where.and.push({"atendenteId": this.user.id});

        // Filtro por tipo de transação
        const tiposTransacao = ['DEPÓSITO', 'TAXA', 'SAQUE', 'ABERTURA_CAIXA', 'SANGRIA_CAIXA'];
        const orTipoTransacao = tiposTransacao.map(tipo => ({ "tipoTransacao": tipo }));
        filtro.where.and.push({ "or": orTipoTransacao });

        // Se formasDePagamento tiver itens, adicione a cláusula 'or' ao filtro
        let formasDePagamento = ['CARTÃO','ESPÉCIE','PIX','TODOS']
        const orClause = formasDePagamento.map(forma => ({ "formaTransacao": forma.toString() }));
        orClause.push({ "formaTransacao": undefined });
        filtro.where.and.push({ "or": orClause });

        // Converta o filtro para uma string e faça a chamada da API
        const filtroString = JSON.stringify(filtro);
        try {
          const response = await axios.get(`${baseApiUrl}ExtratoCartoes?filter=${filtroString}&access_token=${sessionStorage.getItem('accToken')}`);
          this.extratoAtendente = response.data;

          // Resetando o objeto resumo
          this.resumo = {
            abertura: '0,00',
            cartao: '0,00',
            pix: '0,00',
            sangria: '0,00',
            saque: '0,00',
            especie: '0,00'
          };

          // Iterando sobre os registros para calcular os resumos
          for (const registro of this.extratoAtendente) {
            let valor = parseFloat((registro.valor || "0").replace(',', '.')); // Convertendo string "10,12" para número 10.12

            switch (registro.tipoTransacao) {
              case 'ABERTURA_CAIXA':
                this.resumo.abertura = (parseFloat(this.resumo.abertura.replace(',', '.')) + valor).toFixed(2).replace('.', ',');
                break;
              case 'SANGRIA_CAIXA':
                this.resumo.sangria = (parseFloat(this.resumo.sangria.replace(',', '.')) + valor).toFixed(2).replace('.', ',');
                break;
              case 'SAQUE':
                this.resumo.saque = (parseFloat(this.resumo.saque.replace(',', '.')) + valor).toFixed(2).replace('.', ',');
                break;
              case 'DEPÓSITO':
                switch (registro.formaTransacao) {
                  case 'CARTÃO':
                    this.resumo.cartao = (parseFloat(this.resumo.cartao.replace(',', '.')) + valor).toFixed(2).replace('.', ',');
                    break;
                  case 'PIX':
                    this.resumo.pix = (parseFloat(this.resumo.pix.replace(',', '.')) + valor).toFixed(2).replace('.', ',');
                    break;
                  case 'ESPÉCIE':
                    this.resumo.especie = (parseFloat(this.resumo.especie.replace(',', '.')) + valor).toFixed(2).replace('.', ',');
                    break;
                }
                break;
            }
          }
        } catch (error) {
          // console.error("Erro ao carregar transações:", error);
        } finally {
          this.isLoading = false
          this.calcularTotais()
          this.dialogoFecharCaixa = true;
        }
      },

      calcularTotais() {
        let total = 0;
        let totalEspecie = 0;

        // Iterando sobre os registros para calcular o total
        for (const registro of this.extratoAtendente) {
          let valor = parseFloat((registro.valor || "0").replace(',', '.')); // Convertendo string "10,12" para número 10.12

          switch (registro.tipoTransacao) {
            case 'SAQUE':
            case 'SANGRIA_CAIXA':
              totalEspecie -= valor;  // Subtrair para saque
              break;
            case 'ABERTURA_CAIXA':
              totalEspecie += valor;  // Adicionar para os outros tipos
              break;
            case 'DEPÓSITO':
              switch (registro.formaTransacao) {
                case 'ESPÉCIE':
                  totalEspecie += valor;  // Adicionar para espécie
                  break;
              }
              break;
            }
        }

        this.totalEmCaixaEspecie = totalEspecie.toFixed(2).replace('.', ','); // Convertendo de volta para string com vírgula e atribuindo a this.total

        // Iterando sobre os registros para calcular o total
        for (const registro of this.extratoAtendente) {
          let valor = parseFloat((registro.valor || "0").replace(',', '.')); // Convertendo string "10,12" para número 10.12

          switch (registro.tipoTransacao) {
            case 'SAQUE':
            case 'SANGRIA_CAIXA':
              total -= valor;  // Subtrair para saque
              break;
            case 'DEPÓSITO':
            case 'ABERTURA_CAIXA':
              total += valor;  // Adicionar para os outros tipos
              break;
          }
        }

        this.totalEmCaixa = total.toFixed(2).replace('.', ','); // Convertendo de volta para string com vírgula e atribuindo a this.total
      },

      async confirmarFechamento() {
        var vm = this;

        if (this.pinTransacao == this.user.pin) {
          this.isLoading = true
          await axios.post(baseApiUrl + 'Usuarios/upsertWithWhere?where={"id":"' + this.user.id + '"}&access_token=' + sessionStorage.getItem('accToken'), {"caixaAberto": false})
          .then(response => {
            if (response.data) {
              sessionStorage.setItem('user', JSON.stringify(response.data))
              this.resumo = {
                abertura: '0,00',
                cartao: '0,00',
                pix: '0,00',
                sangria: '0,00',
                saque: '0,00',
                especie: '0,00',
                taxa: '0,00'
              };
              this.extratoAtendente = []
              this.isLoading = false
              this.dialogoFecharCaixa = false
              vm.$refs.chamaSnackbar.snack("#0288D1","Caixa Fechado com Sucesso!","INFORMAÇÃO")
              this.dialogoAbrirCaixa = true
            }
          })
          .catch(() => {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao salvar PIN","DESCULPE")
          })
        }
        else {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#EF5350","PIN Incorreto!","DESCULPE")
        }
      },

      async salvarPin() {
        var vm = this;
        this.isLoading = true
        await axios.post(baseApiUrl + 'Usuarios/upsertWithWhere?where={"id":"' + this.user.id + '"}&access_token=' + sessionStorage.getItem('accToken'), {"pin": this.pin})
        .then(response => {
          if (response.data) {
            sessionStorage.setItem('user', JSON.stringify(response.data))
            this.isLoading = false
            this.dialogoCriaPin = false
            vm.$refs.chamaSnackbar.snack("#0288D1","PIN salvo!","INFORMAÇÃO")
          }
        })
        .catch(() => {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao salvar PIN","DESCULPE")
        })
      },

      depositoCartao() {
        this.valorTransacaoCartaoDesconto = 0;
        this.valorTransacaoCartaoAcressimo = 0;
        this.showTextField = false;
        this.$nextTick(() => {
          this.showTextField = true;
        });
        this.valorTransacaoCartaoDesconto = this.valorTransacao
        this.valorTransacaoCartaoAcressimo = this.valorTransacao
        this.calculaDesconto(this.valorTransacao)
        this.calculaAcressimo(this.valorTransacao)
        this.depositDialog  = true
      },

      alteraValor(valor) {
        this.valorTransacao = parseFloat(this.valorTransacao.replace(',','.')) + valor
      },

      async abreLeituraQRCode(tipo, forma, valorCartao) {
        var vm = this;
        if(valorCartao){
          this.valorTransacao = valorCartao
        }
        if (this.valorTransacao == '0,00' && tipo == 'DEPÓSITO') {
          vm.$refs.chamaSnackbar.snack("#F9A825","Informe um valor para continuar!","ATENÇÃO")
        } else if (parseFloat(this.valorTransacao.replace(',','.')) < 1 && tipo == 'DEPÓSITO') {
          vm.$refs.chamaSnackbar.snack("#F9A825","Valor mínimo para recargas é de R$ 1,00","ATENÇÃO")
        } else {
          this.tipoTransacao = tipo
          this.formaTransacao = forma
          this.audio.play()

          if (this.companyobj.reconhecimentoFacial) {
            // this.dialogoSelecaoMetodo = true;
            this.selecionarMetodo('facial')
          }
          else {
            this.metodoTransacao = 'nfc';
            //faz o procedimento para o app ler o cartao
            sessionStorage.removeItem('ativanfc')
            sessionStorage.setItem('ativanfc', 'true')
            this.dialogoCaptura = true
          }
        }
      },

      selecionarMetodo(metodo) {
        this.metodoTransacao = metodo;

        if (metodo === 'nfc') {
          this.abrirLeituraNFC()
        }
        else if (metodo === 'facial') {
          this.dialogoCamera = true
        }

        this.dialogoSelecaoMetodo = false
      },

      async capturarFoto() {
        let vm = this;

        try {
          this.hashBase64 = await this.$refs.camera.capturar();
          this.dialogoCamera = false;

          if (this.hashBase64) {
            if (this.tipoTransacao == 'DEPÓSITO')
              this.dialogoSolicitaPin = true;
            else
              this.fazerConsultaSaldoFacial()
          }
          else {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao capturar foto, tente novamente!", "ERRO");
          }
        } catch (error) {
          vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao capturar foto", "ERRO");
        }
      },

      async decodificar(decodedString) {
        this.codigoQrCode = decodedString
        if (this.formaTransacao == 'PIX') {
          let verificacao = await this.validaQrCode(this.codigoQrCode, 'resultado')
          if (verificacao == 'SUCESSO') {
            this.dialogoPerguntaPagamentoPix = true
          } else if (verificacao == 'CARTAO_CONSUMO_NAO_CADASTRADO') {
            this.dialogoCadastraConsumidor = true
          } else if (verificacao == 'QRCODE_INVALIDO') {
            var vm = this
            vm.$refs.chamaSnackbar.snack("#F9A825","Cartão de consumo inválido","ATENÇÃO")
          }
        } else {
          this.dialogoSolicitaPin = true
        }
        this.dialogoCaptura = false
      },

      async fazerConsultaSaldo(decodedString) {
        var vm = this
        this.isLoading = true
        let resultado = await this.validaQrCode(decodedString, 'resultado')
        if (resultado == 'SUCESSO') {
          let saldo = await this.validaQrCode(decodedString, 'saldo')
          let consumidor = await this.validaQrCode(decodedString, 'consumidor')
          saldo = saldo == '' ? "0,00" : saldo
          sessionStorage.removeItem('nfc')
          vm.$refs.chamaSnackbar.snack("#0288D1", "Seu saldo é de R$ " + saldo, consumidor)
        } else if (resultado == 'CARTAO_CONSUMO_NAO_CADASTRADO') {
          vm.$refs.chamaSnackbar.snack("#F9A825","Cartão de consumo não cadastrado","ATENÇÃO")
        } else if (resultado == 'QRCODE_INVALIDO') {
          vm.$refs.chamaSnackbar.snack("#F9A825","Cartão de consumo inválido","ATENÇÃO")
        } else {
          sessionStorage.removeItem('nfc')
          vm.$refs.chamaSnackbar.snack("#F9A825","Cartão inválido","ATENÇÃO")
        }
        this.dialogoCamera = false
        this.isLoading = false
      },

      async fazerConsultaSaldoFacial() {
        let vm = this
        this.isLoading = true

        await axios.post(baseApiUrl + 'Consumidores/consultaSaldoFacial', { "fotoBase64": this.hashBase64, "empresaId": this.user.empresaId })
        .then(response => {
          if (response.data) {
            if (response.data.resultado == 'SUCESSO') {
              vm.$refs.chamaSnackbar.snack("#0288D1", "Seu saldo é de R$ " + response.data.saldo, response.data.consumidor)
            }
            else {
              vm.$refs.chamaSnackbar.snack("#F9A825", "Consumidor não localizado", "ATENÇÃO")
            }
          }
        })
        .catch(() => {
          vm.$refs.chamaSnackbar.snack("#F9A825", "Consumidor não localizado", "ATENÇÃO")
        })

        this.hashBase64 = ''
        this.isLoading = false
      },

      async criarTransacao() {
        var vm = this;
        this.isLoading = true
        let dados = {
          "empresaId": this.user.empresaId,
          "atendenteId": this.user.id,
          "qrCode": this.codigoQrCode,
          "valor": this.valorTransacao,
          "tipoTransacao": this.tipoTransacao,
          "formaTransacao": this.formaTransacao,
          "pinUsuario": this.pinTransacao,
        }

        if(this.tipoTransacao == 'SAQUE')
          dados.formaTransacao = 'ESPÉCIE'

        const endpoint = this.metodoTransacao === 'facial' && this.modoCaptura === 'FACIAL' ? "CartoesConsumo/novaTransacaoFacial" : "CartoesConsumo/novaTransacao";

        if (this.metodoTransacao === 'facial') {
          dados.fotoBase64 = this.hashBase64;
        }

        await axios.post(baseApiUrl + endpoint + '?access_token=' + sessionStorage.getItem('accToken'), dados)
        .then(response => {
          if (response.data) {
            this.isLoading = false
            this.dialogoCaptura = false
            if (response.data.resultado == 'SUCESSO') {
              this.fechar()
              this.respostaTransacao = response.data
              this.sessionStoragePrinter(this.valorTransacao, this.tipoTransacao, this.formaTransacao, this.respostaTransacao.saldo, this.respostaTransacao.consumidor)
              sessionStorage.removeItem('nfc')
              this.mostraTransacoes()
              this.dialogoOperacao = true
            }
            else if (response.data.resultado == 'SALDO_INSUFICIENTE') {
              this.respostaTransacao = response.data
              this.dialogoOperacao = true
            }
            else if (response.data.resultado == 'CARTAO_CONSUMO_NAO_CADASTRADO') {
              this.dialogoCadastraConsumidor = true
            }
            else if (response.data.resultado == 'QRCODE_INVALIDO') {
              vm.$refs.chamaSnackbar.snack("#F9A825","QR Code inválido","ATENÇÃO")
            }
            else if (response.data.resultado == 'TRANSACAO_INFORMADA_INVALIDA') {
              vm.$refs.chamaSnackbar.snack("#F9A825","Transação informada é inválida","ATENÇÃO")
            }
          }
        })
        .catch(error => {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao criar transação (" + error.response.data.error.message + ")","DESCULPE")
        })
      },

      fechar() {
        this.showTextField = false
        this.depositDialog = false
        this.dialogoSolicitaPin = false
        this.dialogoCaptura = false
        this.dialogoCadastraConsumidor = false
        this.dialogoOperacao = false
        this.pinTransacao = ''
        this.codigoQrCode = ''
      },

      fecharDialogCartao(){
        this.showTextField = false
        this.depositDialog = false
      },

      async criarConsumidor() {
        var vm = this;
        this.isLoading = true
        this.consumidor.qrCode = this.codigoQrCode
        this.consumidor.cpf = this.consumidor.cpf ? this.consumidor.cpf : this.codigoQrCode
        this.consumidor.nome = this.consumidor.nome ? this.consumidor.nome : 'Avulso'
        this.consumidor.whatsApp = this.consumidor.whatsApp ? this.consumidor.whatsApp : this.codigoQrCode
        this.consumidor.empresaId = this.user.empresaId

        await axios.post(baseApiUrl + 'Consumidores/novoConsumidorComCartao?access_token=' + sessionStorage.getItem('accToken'), this.consumidor)
        .then(response => {
          if (response.data) {
            if (this.formaTransacao == 'PIX') {
              this.isLoading = false
              this.dialogoPerguntaPagamentoPix = true
            } else {
              this.criarTransacao()
            }

            this.dialogoCadastraConsumidor = false
          }
        })
        .catch(error => {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao cadastrar consumidor (" + error.response.data.error.message + ")","DESCULPE")
        })
      },

      consultaCPF() {
        axios.get('http://aipass.intelite.com.br:3005/api/inscricoes?filter={"where":{"cpf":"' + this.consumidor.cpf + '"}}')
        .then(response => {
          if (response.data) {
            this.consumidor.nome = response.data[0].nome
            this.consumidor.whatsApp = response.data[0].telefone
          }
        })
      },

      async consultaMatricula() {
        this.consumidor.matricula = this.consumidor.matricula.trim()

        await axios.post(baseApiUrl + 'Consumidores/pelaMatricula', {"matricula": this.consumidor.matricula, "empresaId": this.user.empresaId})
        .then(response => {
          if (response.data) {
            this.consumidor.cpf = response.data.cpf
            this.consumidor.nome = response.data.nome
            this.consumidor.whatsApp = response.data.whatsApp
            this.consumidor.id = response.data.id
            sessionStorage.setItem('senhaCartao', response.data.senha)
          }
        })
      },

      async validaQrCode(qrCode, atributo) {
        let resultado
        await axios.post(baseApiUrl + 'QRCodes/validaQrcode?access_token=' + sessionStorage.getItem('accToken'), {"qrCode": qrCode})
        .then(response => {
          if (response.data) {
            resultado = response.data[atributo]
          }
        })
        .catch(() => {
          resultado = 'Problema ao consultar o cartão de consumo'
        })
        return resultado
      },
      async pagarPixAsaas() {
        var vm = this
        this.isLoading = true
        this.cobrancaAsaas.value = parseFloat(this.valorTransacao.replace(',','.'))
        this.cobrancaAsaas.dueDate = moment().format('YYYY-MM-DD')
        this.cobrancaAsaas.qrCode = this.codigoQrCode
        this.cobrancaAsaas.description = 'Referente a recarga do cartão de consumo nº ' + this.codigoQrCode + ' no AIConsumer'
        this.cobrancaAsaas.empresaId = this.user.empresaId

        await axios.post(baseApiUrl + 'Pagamentos/AsaasCobranca?access_token=' + sessionStorage.getItem('accToken'), this.cobrancaAsaas)
        .then(response => {
          if (response.data) {
            this.isLoading = false
            this.cobrancaPix.id = response.data.paymentId
            this.cobrancaPix.qrCode = "data:image/jpeg;base64," + response.data.qrCode.encodedImage
            this.cobrancaPix.chaveCopiaCola = response.data.qrCode.payload
            this.dialogoPagamentoPix = true
            this.consultaPagamentoPixAsaas()
          }
        }).catch(() => {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao criar transação, tente novamente","DESCULPE")
        })
      },

      async consultaPagamentoPixAsaas() {
        this.verificaPagamento = setInterval(async function() {
          await axios.post(baseApiUrl + 'Pagamentos/AsaasCobrancaConsulta?access_token=' + sessionStorage.getItem('accToken'), {"paymentId": this.cobrancaPix.id}).then(async response => {
            if (response.data.status == 'RECEIVED') {
              clearInterval(this.verificaPagamento)
              this.saldoCartao = await this.validaQrCode(this.codigoQrCode, 'saldo')
              let consumidor = await this.validaQrCode(this.codigoQrCode, 'consumidor')
              this.sessionStoragePrinter(this.cobrancaAsaas.value, 'DEPÓSITO', 'PIX', this.saldoCartao, consumidor)
              sessionStorage.removeItem('nfc')
              this.mostraTransacoes()
              this.dialogoPagamentoPix = false
              this.dialogoConfirmacao = true
            }
          })
        }.bind(this), 5000)
      },

      async pagarPixTaPago() {
        var vm = this
        this.isLoading = true
        let dados = {
          "qrCode": "",
          "valor": parseFloat(this.valorTransacao.replace(',','.')),
          "descricao": "",
          "empresaId": this.user.empresaId,
        }

        if (this.codigoInscricao) {
          dados.qrCode = this.codigoInscricao
          dados.descricao = 'Referente a recarga do cartão de consumo nº ' + this.codigoInscricao + ' no AIConsumer'
        } else {
          dados.qrCode = this.codigoQrCode
          dados.descricao = 'Referente a recarga do cartão de consumo nº ' + this.codigoQrCode + ' no AIConsumer'
        }

        await axios.post(baseApiUrl + 'Pagamentos/taPagoCobranca?access_token=' + sessionStorage.getItem('accToken'), dados)
        .then(response => {
          if (response.data) {
            this.isLoading = false
            this.cobrancaPix.id = response.data.transactionId
            this.cobrancaPix.qrCode = "data:" + response.data.instantPayment.generateImage.mimeType + ";base64," + response.data.instantPayment.generateImage.imageContent
            this.cobrancaPix.chaveCopiaCola = response.data.instantPayment.textContent
            this.dialogoPagamentoPix = true
            this.consultaPagamentoPixTaPago()
          }
        })
        .catch(() => {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao criar transação, tente novamente","DESCULPE")
        })
      },

      async consultaPagamentoPixTaPago() {
        this.verificaPagamento = setInterval(async function() {
          await axios.post(baseApiUrl + 'Pagamentos/taPagoCobrancaConsulta?access_token=' + sessionStorage.getItem('accToken'), {"paymentId": this.cobrancaPix.id})
          .then(async response => {
            if (response.data.status == 'APPROVED') {
              clearInterval(this.verificaPagamento)
              let consumidor

              if (this.codigoInscricao) {
                this.saldoCartao = await this.validaQrCode(this.codigoInscricao, 'saldo')
                consumidor = await this.validaQrCode(this.codigoInscricao, 'consumidor')
              } else {
                this.saldoCartao = await this.validaQrCode(this.codigoQrCode, 'saldo')
                consumidor = await this.validaQrCode(this.codigoQrCode, 'consumidor')
              }

              this.sessionStoragePrinter(this.valorTransacao, 'DEPÓSITO', 'PIX', this.saldoCartao, consumidor)
              sessionStorage.removeItem('nfc')
              this.mostraTransacoes()
              this.dialogoPagamentoPix = false
              this.dialogoConfirmacao = true
            }
          })
        }.bind(this), 5000)
      },

      async pagarPixSicoob() {
        var vm = this;
        this.isLoading = true;

        let dados = {
          empresaId: this.user.empresaId,
          qrCode: "",
          calendario: {
            expiracao: 3600
          },
          devedor: {
            cpf: "",
            nome: "",
          },
          valor: {
            original: parseFloat(this.valorTransacao.replace(",", ".")),
          },
          chave: "",
          solicitacaoPagador: "",
        };

        if (this.codigoInscricao) {
          dados.qrCode = this.codigoInscricao;
          dados.solicitacaoPagador = "Referente a recarga do cartão de consumo nº " + this.codigoInscricao + " no AIConsumer";
        } else {
          dados.qrCode = this.codigoQrCode;
          dados.solicitacaoPagador = "Referente a recarga do cartão de consumo nº " + this.codigoQrCode + " no AIConsumer";
        }

        await axios.post(baseApiUrl + "Pagamentos/sicoobCobranca", dados)
        .then(response => {
          if (response.data) {
            this.cobrancaPix.id = response.data.txid
            this.cobrancaPix.qrCode = response.data.brcode
            this.cobrancaPix.chaveCopiaCola = response.data.brcode
            this.dialogoPagamentoPix = true;
            this.isLoading = false;
            this.consultaPagamentoPixSicoob();
          }
        })
        .catch(() => {
          this.isLoading = false;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao criar transação, tente novamente", "DESCULPE");
        });
      },

      async consultaPagamentoPixSicoob() {
        try {
          this.verificaPagamento = setInterval(
            async function () {
              await axios.post(baseApiUrl + "Pagamentos/sicoobCobrancaConsulta", {"paymentId": this.cobrancaPix.id})
              .then(async res3 => {
                if (res3.data.status == "APPROVED") {
                  clearInterval(this.verificaPagamento);

                  if (this.codigoInscricao) {
                    this.saldoCartao = await this.validaQrCode(this.codigoInscricao, "saldo");
                  }
                  else {
                    this.saldoCartao = await this.validaQrCode(this.codigoQrCode, "saldo");
                  }

                  this.dialogoPagamentoPix = false;
                  this.dialogoConfirmacao = true;
                }
              });
            }.bind(this), 5000);
        } catch (error) {
          clearInterval(this.verificaPagamento);
          this.isLoading = false;
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Não foi possível verificar o pagamento, tente novamente!", "DESCULPE");
        }
      },

      async buscaConsumidor() {
        this.isLoading = true
        this.tabela.conteudo = []
        this.cartoesSelecionados = []
        let url = baseApiUrl + 'Consumidores?filter='

        if (this.tipoBusca == 'CPF') {
          url += '{"where":{"cpf":"' + this.dadoTransferencia + '"}}&access_token=' + sessionStorage.getItem('accToken')
        } else {
          url += '{"where":{"whatsApp":"' + this.dadoTransferencia + '"}}&access_token=' + sessionStorage.getItem('accToken')
        }

        await axios.get(url)
        .then(async response => {
          if (response.data) {
            let dadosConsumidor = []

            for (let i = 0; i < response.data.length; i++) {
              await axios.get(baseApiUrl + 'CartoesConsumo?filter={"where":{"consumidorId":"' + response.data[i].id + '"}}&access_token=' + sessionStorage.getItem('accToken'))
              .then(result => {
                if (result.data) {
                  dadosConsumidor.push({
                    "consumidor": response.data[i].nome,
                    "cpf": response.data[i].cpf,
                    "whatsApp": response.data[i].whatsApp,
                    "qrCode": response.data[i].qrCode,
                    "consumidorId": response.data[i].id,
                    "saldo": result.data[0].saldo,
                    "created": result.data[0].created,
                    "cartaoConsumoId": result.data[0].id,
                  })
                }
              })
            }

            this.tabela.conteudo = dadosConsumidor
            this.dialogoTransferirSaldo = false
            this.dialogoExibeConsumidoreCartao = true
          }
        })

        this.isLoading = false
      },

      transformaData(data, formato) {
        let date = moment(data).format(formato);
        return date
      },

      salvaLeituraQRCodeTransferencia(decode) {
        this.codigoTransferencia = decode
        this.dialogoLeituraQRCodeTransferencia = false
        this.dialogoSolicitaPin = true
      },

      async fazerTransferenciaValor() {
        let vm = this
        let saldoTotal = 0
        this.isLoading = true

        let verificacao = await this.validaQrCode(this.codigoTransferencia, 'resultado')

        if (verificacao == 'SUCESSO' || verificacao == 'CARTAO_CONSUMO_NAO_CADASTRADO' ) {
          for (let i = 0; i < this.cartoesSelecionados.length; i++) {
            let resultado = await this.realizarTransacao('SAQUE', this.cartoesSelecionados[i].qrCode, this.cartoesSelecionados[i].saldo)

            if (resultado != 'SUCESSO') {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#EF5350", resultado, "DESCULPE")
              break
            }
            else {
              saldoTotal += parseFloat(this.cartoesSelecionados[i].saldo.replace(',','.'))
            }
          }

          if (verificacao == 'CARTAO_CONSUMO_NAO_CADASTRADO') {
            this.criaConsumidor(this.codigoTransferencia, this.cartoesSelecionados[0].cpf, this.cartoesSelecionados[0].consumidor, this.cartoesSelecionados[0].whatsApp, async function() {
              let resultado2 = await this.realizarTransacao('DEPÓSITO', this.codigoTransferencia, saldoTotal.toFixed(2).replace('.',','))
              if (resultado2 == 'SUCESSO') {
                this.isLoading = false
                vm.$refs.chamaSnackbar.snack("#0288D1","Transferência de R$" + saldoTotal.toFixed(2).replace('.',',') + " realizada!","SUCESSO")
              }
            })
          } else {
            let resultado2 = await this.realizarTransacao('DEPÓSITO', this.codigoTransferencia, saldoTotal.toFixed(2).replace('.',','))
            if (resultado2 == 'SUCESSO') {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#0288D1","Transferência de R$" + saldoTotal.toFixed(2).replace('.',',') + " realizada!","SUCESSO")
            }
          }

          this.dialogoSolicitaPin = false
          this.pinTransacao = ''
        } else if (verificacao == 'QRCODE_INVALIDO') {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#F9A825","Cartão de consumo inválido","ATENÇÃO")
        }
      },

      async realizarTransacao(tipoTransacao, qrCode, saldo) {
        let retorno
        let dados = {
          "empresaId": this.user.empresaId,
          "atendenteId": this.user.id,
          "qrCode": qrCode,
          "valor": saldo,
          "tipoTransacao": tipoTransacao,
          "pinUsuario": this.user.pin,
        }

        if (tipoTransacao == 'ABERTURA_CAIXA' || tipoTransacao == 'SANGRIA_CAIXA') {
          dados.formaTransacao = 'ESPÉCIE'
          dados.pinUsuario = this.pinTransacao == '' ? this.usuario.pin : this.pinTransacao
        }

        await axios.post(baseApiUrl + 'CartoesConsumo/novaTransacao?access_token=' + sessionStorage.getItem('accToken'), dados)
        .then(response => {
          if (response.data) {
            if (response.data.resultado == 'SUCESSO') {
              retorno = response.data.resultado
            }
          }
        })
        .catch(error => {
          retorno = error.response.data.error.message
        })

        return retorno
      },

      async criaConsumidor(qrCode, cpf, nome, whatsApp, callback) {
        let dados = {
          "qrCode": qrCode,
          "cpf": cpf,
          "nome": nome,
          "whatsApp": whatsApp,
          "empresaId": this.user.empresaId,
        }

        await axios.post(baseApiUrl + 'Consumidores/novoConsumidorComCartao?access_token=' + sessionStorage.getItem('accToken'), dados)

        if (callback) {
          callback()
        }
      },

      sessionStoragePrinter(valorTransacao, tipoTransacao, formaPagamento, novoSaldo, nomeCliente) {
        sessionStorage.setItem('nomeCliente', nomeCliente)
        sessionStorage.setItem('formaPagamento', formaPagamento)
        sessionStorage.setItem('tipoTransacao', tipoTransacao)
        sessionStorage.setItem('valorTransacao', valorTransacao.replace('.',','))
        sessionStorage.setItem('novoSaldo', novoSaldo)
        sessionStorage.setItem('imprimir', 'true')
      },

      async mostraTransacoes() {
        var vm = this
        this.tabela.carregamentoTransacoesMinizado = true
        this.tabela.conteudoTransacoesMinizado = []

        await axios.get(baseApiUrl + 'ExtratoCartoes?filter={"where":{"and":[{"empresaId":"'+this.user.empresaId+'"},{"atendenteId":"'+this.user.id+'"},{"tipoTransacao":"DEPÓSITO"}]},"include":["consumidor"],"limit":5,"order":"created DESC"}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.tabela.conteudoTransacoesMinizado = response.data
          }
        })
        .catch(() => {
          vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao carregar recargas","DESCULPE")
        })

        this.tabela.carregamentoTransacoesMinizado = false
      },

      async mostraHistorico() {
        var vm = this
        this.dialogoHistorico = true
        this.tabela.carregamentoTransacoesCompleto = true
        this.tabela.conteudoTransacoesCompleto = []

        await axios.get(baseApiUrl + 'ExtratoCartoes?filter={"where":{"and":[{"empresaId":"'+this.user.empresaId+'"},{"atendenteId":"'+this.user.id+'"},{"tipoTransacao":"DEPÓSITO"}]},"include":["consumidor"],"order":"created DESC"}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            for (let i = 0; i < response.data.length; i++) {
              this.tabela.conteudoTransacoesCompleto.push({
                "nome": response.data[i].consumidor ? response.data[i].consumidor.nome : 'Consumidor não identificado',
                "valor": response.data[i].valor,
                "tipoTransacao": response.data[i].tipoTransacao,
                "id": response.data[i].id,
                "created": response.data[i].created,
              })
            }
          }

          this.tabela.carregamentoTransacoesCompleto = false
        })
        .catch(() => {
          this.tabela.carregamento = false
          vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao carregar histórico","DESCULPE")
        })
      },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      fechaDialogoPerguntaPagamento() {
        if (this.companyobj.gatewayPagamentoPix == 'ASAAS') {
          this.pagarPixAsaas()
        }
        else if (this.companyobj.gatewayPagamentoPix == 'TAPAGO') {
          this.pagarPixTaPago()
        }
        else if (this.companyobj.gatewayPagamentoPix == 'SICOOB') {
          this.pagarPixSicoob();
        }

        this.dialogoPerguntaPagamentoPix = false
      },

      async carregaConsumidores(data) {
        this.autocompleteConsumidor.carregamento = true

        let whereFilter = {
          "where": {
            "and": [
              { "empresaId": this.companyobj.id },
            ]
          },
          "order": "nome ASC"
        }

        if (!isNaN(data.replace(/\D/g, '')) && parseInt(data.replace(/\D/g, '')) > 0) {
          whereFilter.where.and.push({ "matricula": {"regexp": "/" + data + "/i" } })
        }
        else {
          whereFilter.where.and.push({ "nome": {"regexp": "/" + data + "/i"} })
        }

        await axios.get(baseApiUrl + 'Consumidores?filter=' + JSON.stringify(whereFilter) + '&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data) {
            this.autocompleteConsumidor.conteudo = response.data
          }
        })
        .catch(error => {
          this.$refs.chamaSnackbar.snack("red", "Problema ao buscar consumidores. " + error.response.data.error.message, "DESCULPE")
        })

        this.autocompleteConsumidor.carregamento = false
      },

      filterConsumidores(item, queryText) {
        let searchText = queryText.toLowerCase()
        let nome = item.nome ? item.nome.toLowerCase() : ''
        let matricula = item.matricula ? item.matricula.toLowerCase() : ''
        
        return nome.includes(searchText) || matricula.includes(searchText)
      },
    },
    directives: {money: VMoney}
  }
</script>

<style scoped>
  .limiter {
    width: 100%;
    margin: 0 auto;
  }

  .container-login {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 15px;
    background: linear-gradient(to right, #474d55, #474d55);
    background-repeat: no-repeat;
    position: relative;
    z-index: 1;
  }

  .texto {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  .login {
    min-width: 80%;
    border-radius: 15px;
    background-color: #fff;
    opacity: 0.9;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .login-title {
    display: block;
    margin-left: auto;
    margin-right: auto;
    text-align: center
  }

  a {
    text-decoration: none
  }
</style>